import React, { ComponentProps } from 'react';
import IUrl from '../../types/IUrl';
import { UserProfileSelection } from '../../_lib/components/UserProfileSelection/UserProfileSelection';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useSonTranslation } from '../../translation/useSonTranslation';

type UserAnonymousProps = { loginUrl?: IUrl };

function UserAnonymous({ loginUrl }: UserAnonymousProps) {
  const { t } = useSonTranslation('UserAnonymous');
  return (
    <UserProfileSelection
      headline={t('headline')}
      helpText={t('helpText')}
      loginLink={loginUrl?.url}
      loginLinkText={t('loginText')}
    />
  );
}
export const UserAnonymousBlock = asFetchableBlock(UserAnonymous, BlockType.useranonymous);
export type UserAnonymousBlock = ComponentProps<typeof UserAnonymousBlock>;
